import React, { Component } from 'react'

export default class Logo extends Component {
  render() {

    if (this.props.small) {
      return(
        <div className='container mt-3' style={{position: 'relative', textAlign: 'center', }}>        
          <img src={'logo_no_shadow.svg'} style={{height: '10vh'}}/>
        </div>
      )
    }

    return (
      <div className='' style={{position: 'relative', textAlign: 'center'}}>
        
        <img src={'logo_no_shadow.svg'} style={{height: '20vh'}}/>
        
        <p style={{
          position: 'absolute',
          bottom: '20%',
          left: '50%',
          transform: 'translate(-50%, 0)',
          fontWeight: 'bold',
          color: 'gray'            
        }}>
        By Siemens Mobility Portugal
        </p>
        
      </div>
        
    )
  }
}
